import React from 'react'
import Header from '../Components/Header/Header'
import AccountP from '../Components/Account/AccountP'

function AccountPro() {
  return (
    <div>
        <Header></Header>
        <AccountP></AccountP>
    </div>
  )
}

export default AccountPro